import { defineMessages } from "react-intl";

export const calloutTitleMessages = defineMessages({
  info: {
    defaultMessage: "Info",
    description: "callout, title",
    id: "BnB/7Y",
  },
  warning: {
    defaultMessage: "Warning",
    description: "callout, title",
    id: "UUVUyy",
  },
});
